export enum COLORS {
  DARK = '#141414',
  WHITE = '#FFF',
  PRIMARY = '#5B4FF9',
  SECONDARY = '#4B98CF',
  BACKGROUND = '#EAEAEE',
  GRAY_200 = '#F6F6F8',
  GRAY_300 = '#EEEEF0',
  GRAY_500 = '#AEB4BB',
  GRAY_700 = '#91979F',
  LIGHT = '##E5E5E5',
  LIGHT_GREEN = '#4CD6BE',
  LIGHT_RED = '#EB8888',
  CYAN = '#50E3CA',
  CYAN_100 = '#8CE4D5',
  CYAN_200 = '#D9F9F1',
  PURPLE_DARK = '#D2B8FF',
  PURPLE_LIGHT = '#DACAF5',
  BLUE_200 = '#ACD7F6',
  BLUE_300 = '#DAEDFB',
  AZURE_LIGHT = '#F0F6FB',
  ORANGE_DARK = '#F9E0A9',
  ORANGE_LIGHT = '#FCEFD4',
  SHADOW_COLOR = '#171717',
  VIOLET_600 = '#3B2DF5',
}
